/** caches for each droppable container's virtualized list item heights */
import { CellMeasurerCache } from 'react-virtualized';

/** Map of droppableId → cache */
export const caches = {};

/** Helper to create (or return) a cache for a droppable */
export const getCacheForDroppable = (droppableId) => {
  if (!caches[droppableId]) {
    caches[droppableId] = new CellMeasurerCache({
      fixedWidth: true,
      fixedHeight: false,
      defaultHeight: 68,
    });
  }
  return caches[droppableId];
};
